import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { verifyEmailToken } from '../../api/authService';
import '../../styles/auth.scss';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');
  const id = searchParams.get('id');

  useEffect(() => {
    const verify = async () => {
      if (!token || !id) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        const { data } = await verifyEmailToken(token, id);
        setStatus('success');
        setMessage(data.message);
      } catch (err) {
        const errorMsg = err.response?.data?.message || 'Verification failed';
        
        // Handle "already verified" as success, not error
        if (errorMsg.toLowerCase().includes('already verified')) {
          setStatus('success');
          setMessage('Your email is already verified. You can log in now!');
        } else {
          setStatus('error');
          setMessage(errorMsg);
        }
      }
    };

    verify();
  }, [token, id]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        {status === 'loading' && (
          <>
            <div className="auth-header">
              <h1>Verifying Email...</h1>
              <p>Please wait while we verify your email</p>
            </div>
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="auth-header">
              <h1>✅ Email Verified!</h1>
              <p>Your account has been activated</p>
            </div>
            <div className="auth-success-alert">{message}</div>
            <Link to="/login" className="btn-auth">
              Go to Login
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="auth-header">
              <h1>❌ Verification Failed</h1>
              <p>We couldn't verify your email</p>
            </div>
            <div className="auth-error-alert">{message}</div>
            <div className="auth-footer">
              <Link to="/login">Go to Login</Link>
              {' | '}
              <Link to="/register">Register Again</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
